import type { InsightContent } from "./types";
import { auditVsStrategy } from "./auditVsStrategy";
import { technicalPrioritization } from "./technicalPrioritization";
import { seoForAiSearch } from "./seoForAiSearch";
import { geoAeoAiSeo } from "./geoAeoAiSeo";
import { keywordsNotInternational } from "./keywordsNotInternational";
import { hispanicMarketSeo } from "./hispanicMarketSeo";
import { categoryVsProduct } from "./categoryVsProduct";
import { amazonSeoVsAds } from "./amazonSeoVsAds";
import { consultantVsAgency } from "./consultantVsAgency";

/** Todas las piezas publicadas de la Search Library, en orden editorial. */
export const insights: InsightContent[] = [
  auditVsStrategy,
  technicalPrioritization,
  seoForAiSearch,
  geoAeoAiSeo,
  keywordsNotInternational,
  hispanicMarketSeo,
  categoryVsProduct,
  amazonSeoVsAds,
  consultantVsAgency,
];

/** Clusters temáticos y su money page asociada. Orden = prioridad comercial. */
export const clusters = [
  {
    id: "SEO Strategy",
    es: { name: "Estrategia SEO", description: "Cómo se decide dónde invertir en búsqueda antes de ejecutar." },
    en: { name: "SEO Strategy", description: "How to decide where to invest in search before executing." },
    moneyPage: { es: "/consultor-seo", en: "/en/seo-consultant" },
  },
  {
    id: "Technical SEO",
    es: { name: "SEO técnico", description: "Rastreo, indexación, renderizado y priorización de arreglos." },
    en: { name: "Technical SEO", description: "Crawling, indexing, rendering and fix prioritisation." },
    moneyPage: { es: "/servicios/seo-tecnico", en: "/en/services/technical-seo" },
  },
  {
    id: "AI Search",
    es: { name: "AI Search", description: "Visibilidad en respuestas generativas y asistentes." },
    en: { name: "AI Search", description: "Visibility inside generative answers and assistants." },
    moneyPage: { es: "/servicios/posicionamiento-llm", en: "/en/services/llm-positioning" },
  },
  {
    id: "International SEO",
    es: { name: "SEO internacional", description: "Multi-mercado, hreflang y demanda por país." },
    en: { name: "International SEO", description: "Multi-market strategy, hreflang and demand by country." },
    moneyPage: { es: "/servicios/seo-internacional", en: "/en/services/international-seo" },
  },
  {
    id: "Hispanic Search",
    es: { name: "Búsqueda hispana en EE. UU.", description: "Cómo busca en español el mercado hispano estadounidense." },
    en: { name: "US Hispanic search", description: "How the US Hispanic market searches in Spanish." },
    moneyPage: { es: "/servicios/seo-bilingue-mercado-hispano", en: "/en/services/hispanic-market-seo" },
  },
  {
    id: "Ecommerce SEO",
    es: { name: "Ecommerce SEO", description: "Categorías, fichas de producto y navegación facetada." },
    en: { name: "Ecommerce SEO", description: "Categories, product pages and faceted navigation." },
    moneyPage: { es: "/servicios/ecommerce-seo", en: "/en/services/ecommerce-seo" },
  },
  {
    id: "Amazon Search",
    es: { name: "Amazon", description: "Búsqueda dentro del marketplace: orgánico frente a pago." },
    en: { name: "Amazon", description: "Search inside the marketplace: organic versus paid." },
    moneyPage: { es: "/servicios/amazon-consulting", en: "/en/services/amazon-consulting" },
  },
] as const;

export const insightsByCluster = (clusterId: string) => insights.filter((i) => i.cluster === clusterId);

export const insightPaths = insights.flatMap((i) => [i.path.es, i.path.en]);
